import Nav from '../components/Nav'
import {useState} from 'react'
import AuthModal from "../components/AuthModal";
const Home = (addAuthToken) => {
    const [showModal, setShowModal] = useState(true)
    const [ isSignUp, setIsSignUp] = useState(false)
    const authToken = false

    const handleClick = () =>{
        setIsSignUp(true)
    }
    return (
        <div className="app-wrapper">
            <Nav
                authToken={authToken}
                setShowModal={setShowModal}
                showModal={showModal}
                isSignUp={isSignUp}
                setIsSignUp={setIsSignUp}
                isLoggedIn={false}
            />
            <div className="home">
                <div class="home-marketing">

                    <p>Finde einzigartige Kleidungsstücke von ausgewählten Shops oder Menschen in deiner Nähe.</p>
                    <div class="hero-image-placeholder">
                        <div class="img-placeholder-box"></div>                    
                    </div>
                </div>
                <div className="home-app-container">
                    <div class="overlay"></div>
                    <h1>Gibher Kleider</h1>
                    <AuthModal setShowModal={true} isSignUp={isSignUp} addAuthToken={addAuthToken}/>
                    {!isSignUp ? <button className="primary-button" onClick={handleClick}>Konto erstellen</button>: 
                    <div></div>}
                </div>
            </div>
            <footer class="home-footer">
                <div class="footer-content">
                <span>&copy; 2026 Gibher Kleider</span>
                <div class="footer-links">
                    <a href="#">AGB</a>
                    <a href="#">Privacy</a>
                    <a href="#">Terms</a>
                </div>
                </div>
            </footer>
        </div>

)
}
export default Home